import axios from 'axios'
import ApiResponse from './apiresponse'
import router from '../router'
import store from '../store'

export default class Api {

  // static baseUrl = 'http://vfapistaging.tropa.mx/api/'
  //static baseUrl = 'http://verdaderofalso-api.tropa.mx/api/'
  static baseUrl = 'https://api.verdaderofalso.com/api/'

  static get (endpoint, async = false) {
    if (async) {
      return Api._asyncGet(endpoint)
    } else {
      return Api._get(endpoint)
    }
  }

  static _get (endpoint) {
    return Api.service().get(endpoint).then(response => {
      if (response.status === 200) {
        return new ApiResponse(true, response.data.body)
      }
    }).catch(e => {
      if (e.response.status === 401) Api.gotoLogin()
      return new ApiResponse(false, e.response.data.body ? e.response.data.body : e.response.data, e.response.status)
    })
  }

  static _asyncGet (endpoint) {
    return new Promise((resolve, reject) => {
      // console.log('here', endpoint)
      return Api.service().get(endpoint).then(response => {
        if (response.status === 200) {
          resolve(new ApiResponse(true, response.data.body))
        }
      }).catch(e => {
        if (e.response.status === 401) Api.gotoLogin()
        reject(new ApiResponse(false, e.response.data.body ? e.response.data.body : e.response.data, e.response.status))
      })
    })
  }

  static post (endpoint, requestBody, async = false) {
    if (async) {
      return Api._asyncPost(endpoint, requestBody)
    } else {
      return Api._post(endpoint, requestBody)
    }
  }

  static _post (endpoint, requestBody) {
    return Api.service().post(endpoint, requestBody).then(response => {
      if (response.status === 200) {
        return new ApiResponse(true, response.data.body)
      }
    }).catch(e => {
      if (e.response.status === 401) {
        Api.gotoLogin()
      }
      return new ApiResponse(false, e.response.data.body ? e.response.data.body : e.response.data, e.response.status)
    })
  }

  static _asyncPost (endpoint, requestBody) {
    return new Promise((resolve, reject) => {
      return Api.service().post(endpoint, requestBody).then(response => {
        if (response.status === 200) {
          resolve(new ApiResponse(true, response.data.body))
        }
      }).catch(e => {
        if (e.response.status === 401) {
          Api.gotoLogin()
        }
        reject(new ApiResponse(false, e.response.data.body ? e.response.data.body : e.response.data, e.response.status))
      })
    })
  }

  static gotoLogin () {
    localStorage.removeItem('access_token')
    store.commit('DESTROY_TOKEN')
    store.commit('DESTROY_USER_DETAILS')
    router.push({
      name: 'login'
    })
  }

  static service () {
    if (store.getters.loggedIn) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.accessToken
      axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
      axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    }
    return axios.create({
      baseURL: Api.baseUrl
    })
  }

  static fullEndpoint (endpoint) {
    return Api.baseUrl + endpoint
  }
}
